<template>
  <div class="bg-[#fff] py-[14] border-[#dadada] border-solid" :class="{ 'border-b-[1px]': border }">
    <div :style="{ width: width }" class="mx-[auto] flex items-center justify-between max-w-[1200]">
      <dg-logo></dg-logo>
      <div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
  mixins: [mixin],
  name: "dg-head",
  props: {
    width: {
      type: String,
      default: "1200px",
    },
    border: {
      type: Boolean,
      default: true,
    },

  },
  data() {
    return {};
  },
  methods: {},
  mounted() { },
  created() { },
};
</script>
<style scoped lang="less">
.ff-yiBin {
  font-family: "Microsoft YaHei", "微软雅黑", "PingFang SC", "Hiragino Sans GB", "Heiti SC", sans-serif !important;
}
</style>
